import React from 'react'
import { BasePreDetail } from 'App/Screens/SubModules/Component'
import PageAdd from './AddV2'
import PageDetail from './DetailV2'

class UserTrackerManagement extends BasePreDetail {
  constructor(props) {
    super(props)

    this.appName = 'account'
    this.modelName = 'user'
  }

  getPageAdd = () => <PageAdd {...this.props} />

  getPageDetail = () => <PageDetail {...this.props} currentPermissionSet={this.state.currentPermissionSet} />
}

export default UserTrackerManagement